import {DemandValidation} from "../constants/DemandValidation";
import {PublishConst} from "../constants/PublicationConst";
import {isDemandModification} from "./getDemandStatus";
import {DemandValidationSectionStatus} from "../constants/DemandValidationSectionStatus";
import NationalNoticeStatus from "../components/complex/nationalNotice/constants/NationalNoticeStatus";

export default (demandValidation, ojsPublicationStatus, bzpContractNoticeStatus) => {
    if (!demandValidation) return false;

    const publicationSection = demandValidation.find(x => x.section === DemandValidation.PUBLICATION);
    if (!(isDemandModification()) || publicationSection?.waitingForPublication) {
        return false;
    }

    const notice = demandValidation.find((x) => x.section === DemandValidation.NOTICE);
    const isNoticeAvailable = notice ? notice.status !== DemandValidationSectionStatus.UNAVAILABLE : false;
    const bzpNotice = demandValidation.find((x) => x.section === DemandValidation.NATIONAL_NOTICE);
    const isBzpNoticeAvailable = bzpNotice ? bzpNotice.status !== DemandValidationSectionStatus.UNAVAILABLE : false;
    if (isNoticeAvailable) {
        return ojsPublicationStatus ? (ojsPublicationStatus.status === PublishConst.NOT_SENT || ojsPublicationStatus.status === PublishConst.UNAVAILABLE) : false;
    } else if (isBzpNoticeAvailable) {
        return bzpContractNoticeStatus ? (bzpContractNoticeStatus.status === NationalNoticeStatus.NONE
            || bzpContractNoticeStatus.status === NationalNoticeStatus.DRAFT || bzpContractNoticeStatus.status === NationalNoticeStatus.COMPLETED) : false;
    }

    return true;
}
